import type { ProductListItem as ProductListItemType } from '../../types/types';
import ProductListItem from './product-list-item';

interface ProductListProps {
  products: ReadonlyArray<ProductListItemType>;
}

export default function ProductList({ products }: ProductListProps) {
  return (
    <ul className="product-list">
      {products.map(product => (
        <li key={product.id} className="product-list-item">
          <ProductListItem product={product} />
        </li>
      ))}
    </ul>
  );
}
